import React, {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router";
import "./CoursePage.sass"
import CircleButton from "../../../../_components/common/buttons/CircleButton";
import CloseIcon from '@mui/icons-material/Close';
import {useDispatch, useSelector} from "react-redux";
import {getCourses} from "../../../../_actions/commonService";
import Window from "../../../../_containers/window/Window";
import ButtonComponent from "../../../../_components/common/buttons/ButtonComponent";
import {ReactComponent as AgeSvg} from "../../../../images/release/course/age.svg";
import {ReactComponent as SandWatchSvg} from "../../../../images/release/course/sand-watch.svg";
import {ReactComponent as WatchSvg} from "../../../../images/release/course/watch.svg";
import {ReactComponent as LongSvg} from "../../../../images/release/course/long.svg";
import {ReactComponent as MonitorSvg} from "../../../../images/release/course/monitor.svg";
import Mental from "./items/Mental";
import Olympics from "./items/Olympics";
import PrepareSchool from "./items/PrepareSchool";
import Art from "./items/Art";
import Russian from "./items/Russian";
import Secret from "./items/Secret";
import QuickReadingPlus from "./items/QuickReadingPlus";
import QuickReading from "./items/QuickReading";
import TechReading from "./items/TechReading";
import Memory from "./items/Memory";
import Learning from "./items/Learning";
import {ADDRESS} from "../../../../_api/client";
import {COURSES} from "../../../../common/links";

export default function CoursePage() {
    const {data, status} = useSelector(state => state.common.courses)
    const [svgBody, setSvgBody] = useState(null);
    const params = useParams();
    const id = parseInt(params.id)
    const dispatch = useDispatch();

    const navigate = useNavigate();
    useEffect(() => {
        if (status === 'idle') {
            dispatch(getCourses())
        }
    }, [status, dispatch]);

    const course = data ? data.filter(item => item.id === id)[0] : undefined

    useEffect(() => {
        if (course && course.avatar) {
            fetch(`${ADDRESS}/avatar/svg/${course.avatar}`)
                .then(res => res.text())
                .then(setSvgBody)
        }
    }, [data]);

    const renderCourse = () => {
        switch (id) {
            case 1: return <Mental/>
            case 2: return <Olympics/>
            case 3: return <PrepareSchool/>
            case 4: return <Art/>
            case 5: return <Russian/>
            case 6: return <Secret/>
            case 7: return <QuickReadingPlus/>
            case 8: return <QuickReading/>
            case 9: return <TechReading/>
            case 10: return <Memory/>
            case 11: return <Learning/>
            default: return <Mental/>
        }
    }

    return (
        <Window>
            <div className="course-header">
                <div className="course-header-icon-price">
                    <div className="course-header-icon"
                         dangerouslySetInnerHTML={{__html: course && course.avatar && svgBody}}>
                        {/*<img src={`${ADDRESS}/avatar/svg/${course.avatar}`} alt={course.name}/>*/}
                    </div>
                </div>
                <div className="course-header-name">{course && course.name}</div>
                <div className="course-header-close">
                    <CircleButton Icon={CloseIcon} link={COURSES}/>
                </div>
            </div>
            <div className="course-short-data">
                <div className="course-short-data-item">
                    <div className="course-short-data-item-img">
                        <AgeSvg/>
                    </div>
                    <div>
                        <div>Возраст:</div>
                        <div className="course-short-data-item-value">{course && course.age}</div>
                    </div>
                </div>
                <div className="course-short-data-item">
                    <div className="course-short-data-item-img">
                        <SandWatchSvg/>
                    </div>
                    <div>
                        <div>Время:</div>
                        <div className="course-short-data-item-value">{(course && course.lessonTime) || "-"} мин.</div>
                    </div>
                </div>
                <div className="course-short-data-item">
                    <div className="course-short-data-item-img">
                        <WatchSvg/>
                    </div>
                    <div>
                        <div>Регулярность:</div>
                        <div className="course-short-data-item-value">{(course && course.regularity )|| "-"}</div>
                    </div>
                </div>
                <div className="course-short-data-item">
                    <div className="course-short-data-item-img">
                        <LongSvg/>
                    </div>
                    <div>
                        <div>Длительность:</div>
                        <div className="course-short-data-item-value">{(course && course.courseTime) || "-"}</div>
                    </div>
                </div>
                <div className="course-short-data-item">
                    <div className="course-short-data-item-img">
                        <MonitorSvg/>
                    </div>
                    <div>
                        <div>Формат:</div>
                        <div className="course-short-data-item-value">{(course && course.type) || "-"}</div>
                    </div>
                </div>
            </div>
            {/*<div className="course-footer" dangerouslySetInnerHTML={{__html: course.description}}></div>*/}
            <div className="course-footer">
                {renderCourse()}
            </div>
            <div className="course-button-panel">
                <ButtonComponent onClick={() => navigate("request")}>Записаться</ButtonComponent>
            </div>
        </Window>
    )
}